/* <rr-locale-memory> — la web recuerda el país y el idioma que el cliente elige en el
   selector y se los devuelve la próxima vez que entra desde fuera (marcador, Google,
   Instagram). Shopify no lo hace dentro de la UE porque no puede redirigir por
   ubicación; aquí solo se reaplica una elección explícita del propio cliente.
   - Al enviar un formulario de localización se marca la sesión; en la página
     siguiente, ya redirigida por Shopify, se guarda el país e idioma resultantes.
   - En una página de entrada (referrer vacío o de otro sitio), si lo guardado no
     coincide con lo servido, se reenvía el formulario una sola vez por sesión.
   El idioma ya lo cambia antes snippets/locale-detect.liquid (en el <head>, sin
   pintar); aquí queda sobre todo el país, que solo se puede fijar con el formulario.
   - Si nunca eligió país (24 oct 2026): el país en que está. En Basic Shopify no lo
     detecta por IP y todo visitante de la UE entraba como España (su ficha de cliente, las
     etiquetas country- del email, el país de envío por defecto). Se pregunta a Shopify
     (browsing_context_suggestions.json) y, si es otro país de la tienda con la misma
     moneda, se fija con el mismo formulario pero en segundo plano: no recarga, no cambia
     el idioma ni el precio, y en esta página se corrigen las etiquetas del formulario de
     email. Una vez por sesión y solo en la página de entrada; una elección a mano manda. */
(() => {
  if (customElements.get('rr-locale-memory')) return;

  const KEY = 'rr-locale';
  const PENDING = 'rr-locale-pending';
  const TRIED = 'rr-locale-tried';
  const ENTRY = 'rr-locale-entry'; // lo deja locale-detect al saltar de idioma en la entrada
  const GEO = 'rr-locale-geo'; // ya se miró el país detectado en esta sesión
  const get = (store, key) => {
    try {
      return store.getItem(key);
    } catch (e) {
      return null;
    }
  };
  const set = (store, key, value) => {
    try {
      store.setItem(key, value);
    } catch (e) {}
  };
  const del = (store, key) => {
    try {
      store.removeItem(key);
    } catch (e) {}
  };

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (form instanceof HTMLFormElement && form.querySelector('input[name="form_type"][value="localization"]')) {
        set(sessionStorage, PENDING, '1');
      }
    },
    true
  );

  class RRLocaleMemory extends HTMLElement {
    connectedCallback() {
      // la página ya se va a otro idioma: no pisar esa navegación
      if (window.rrLocaleRedirecting) return;
      const now = { country: this.dataset.country, locale: this.dataset.locale };

      if (get(sessionStorage, PENDING)) {
        del(sessionStorage, PENDING);
        set(localStorage, KEY, JSON.stringify(now));
        return;
      }

      const entry = get(sessionStorage, ENTRY);
      del(sessionStorage, ENTRY);

      let saved = null;
      try {
        saved = JSON.parse(get(localStorage, KEY) || 'null');
      } catch (e) {}
      if (!saved || !saved.country || !saved.locale) {
        this.geo(now);
        return;
      }
      if (saved.country === now.country && saved.locale === now.locale) return;
      if (get(sessionStorage, TRIED)) return;

      let internal = false;
      try {
        internal = document.referrer !== '' && new URL(document.referrer).origin === location.origin;
      } catch (e) {}
      if (internal && !entry) return;

      const form = this.querySelector('form');
      if (!form) return;
      set(sessionStorage, TRIED, '1');
      // lo que Shopify acabe sirviendo pasa a ser lo guardado: si un idioma no existe en
      // ese país, no se vuelve a intentar en cada visita
      set(sessionStorage, PENDING, '1');
      form.elements.country_code.value = saved.country;
      form.elements.language_code.value = saved.locale;
      form.submit();
    }

    async geo(now) {
      if (get(sessionStorage, GEO)) return;
      if (/bot|crawl|spider|slurp|lighthouse/i.test(navigator.userAgent)) return;
      set(sessionStorage, GEO, '1');
      const form = this.querySelector('form');
      if (!form) return;
      const currencies = {};
      for (const pair of (this.dataset.countries || '').split(',')) {
        const [code, cur] = pair.split(':');
        if (code) currencies[code] = cur;
      }
      try {
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const res = await fetch(`${root}browsing_context_suggestions.json?country[enabled]=true&country[exclude]=${now.country}`, { credentials: 'same-origin' });
        const data = await res.json();
        const geo = data && data.detected_values && data.detected_values.country && data.detected_values.country.handle;
        if (!geo || geo === now.country || !currencies[geo] || currencies[geo] !== this.dataset.currency) return;
        const body = new URLSearchParams(new FormData(form));
        body.set('country_code', geo);
        body.set('language_code', now.locale);
        body.set('return_to', location.pathname);
        await fetch(form.action, { method: 'POST', body, credentials: 'same-origin', redirect: 'manual' });
        // el formulario de email de esta página ya salió con el país de antes
        for (const input of document.querySelectorAll('input[name="contact[tags]"]')) {
          input.value = input.value.replace(/country-[A-Z]{2}/, `country-${geo}`);
        }
        document.documentElement.dataset.rrGeo = geo;
      } catch (e) {}
    }
  }

  customElements.define('rr-locale-memory', RRLocaleMemory);
})();
